export const environment = {
  production: true,
  civBaseURL: 'https://rpv.rabobank.nl/',
  civServicesBaseURL: 'https://rpv.rabobank.nl/civ_services/',
  civViewBaseURL: 'https://rpv.rabobank.nl/civ_view/',
  productViewDetailsBaseURL: 'https://rpv.rabobank.nl/civ_services/',
  financieringsbeeldURL: 'https://financingoverview.businesslending.rabobank.nl/prweb/PRAuth/SAML/LaunchFOV/',
  clientId: 'ab70d836-3634-49c4-939f-7b27a2822fff',
  apiScopes: [
    'https://raboweb.onmicrosoft.com/RPV_MVP_MFA_PROD/User.Read'
  ]

};
